import { render, staticRenderFns } from "./contacts-service.vue?vue&type=template&id=0d0d596e"
import script from "./contacts-service.vue?vue&type=script&lang=js"
export * from "./contacts-service.vue?vue&type=script&lang=js"
import style0 from "./contacts-service.vue?vue&type=style&index=0&id=0d0d596e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports